import { render, staticRenderFns } from "./PanelBuildStats.vue?vue&type=template&id=01f90e16&"
import script from "./PanelBuildStats.vue?vue&type=script&lang=js&"
export * from "./PanelBuildStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports